import { render, staticRenderFns } from "./CompanySideMenu.vue?vue&type=template&id=0ca7b797"
import script from "./CompanySideMenu.vue?vue&type=script&lang=js"
export * from "./CompanySideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ca7b797')) {
      api.createRecord('0ca7b797', component.options)
    } else {
      api.reload('0ca7b797', component.options)
    }
    module.hot.accept("./CompanySideMenu.vue?vue&type=template&id=0ca7b797", function () {
      api.rerender('0ca7b797', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/company/CompanySideMenu.vue"
export default component.exports